import { useParams, Navigate } from 'react-router-dom';
import { useUser } from '../queries/use-user';
import { Spinner } from '@cimplico/components';
import { useFirmContext } from '../providers/FirmProvider';
import UserDetails from '../features/user-overview/user-details/UserDetails';
import UserSettings from '../features/user-overview/user-settings/UserSettings';
import ErrorSplashScreen from './ErrorSplashScreen';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useIsFirmRole } from '../hooks/use-is-firm-role';
import { useUserContext } from '../providers/UserProvider';
import NewPageContainer from '../components/page-container/NewPageContainer';

const tabs = ['Profile', 'Open Workpapers'];

function UserOverviewPage(): JSX.Element {
    const { id } = useParams();
    const { shortId } = useFirmContext();
    const { id: currentUserId } = useUserContext();
    const { isAdmin, isExternalUser } = useIsFirmRole();
    const userQuery = useUser(id);

    if (isExternalUser && currentUserId !== id) {
        return <Navigate to={`/${shortId}/dashboard`} />;
    }

    if (userQuery.isLoading) {
        return (
            <div className="absolute w-full h-[var(--remaining-screen-height)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner />
                </div>
            </div>
        );
    }

    if (userQuery.isError || !userQuery.isSuccess) {
        if (userQuery.error?.response?.status === 404) {
            return (
                <ErrorSplashScreen
                    errorCode={404}
                    title="User not found."
                    redirectTitle="Back to users"
                    redirectUrl={`/${shortId}/users`}
                    leftArrow={true}
                />
            );
        }
        return (
            <ErrorSplashScreen
                title="An error has occurred."
                redirectTitle="Back to users"
                redirectUrl={`/${shortId}/users`}
                leftArrow={true}
            />
        );
    }

    const { user } = userQuery.data;

    return (
        <NewPageContainer>
            <div className="grid gap-y-4 mx-8 xl:mx-auto max-w-[1240px]">
                <UserDetails user={user} />
                <UserSettings user={user} />
            </div>
        </NewPageContainer>
    );
}
export default UserOverviewPage;
